export default __webpack_public_path__ + "static/automotive3-719ad7226cc0c708ebb63a4f3d06620f.jpeg";